import React from 'react';

import Router from 'ff/debrief/router';

import * as API from 'ff/debrief/features/TracklogApi';
import DebriefThemeProvider from 'ff/debrief/components/DebriefThemeProvider';
import ToastBar from 'ff/debrief/components/ToastBar';
import ProductDetailsPage from 'ff/debrief/components/ProductDetailsPage';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

export const DebriefApp = () => {
    const tracklogsQuery = API.useGetAllTracklogsQuery({ page: 0 });
    const sharedTracklogsQuery = API.useGetAllSharedTracklogsQuery();
    const isEmptyList =
        tracklogsQuery.data?.totalTracklogs === 0 &&
        sharedTracklogsQuery.data?.length === 0;
    if (isEmptyList) {
        return (
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <DebriefThemeProvider>
                    <ProductDetailsPage />
                </DebriefThemeProvider>
            </LocalizationProvider>
        );
    }
    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <DebriefThemeProvider>
                <ToastBar />
                <Router />
            </DebriefThemeProvider>
        </LocalizationProvider>
    );
};

export default DebriefApp;
